import service from '../axios'

const WEBSITE_TYPE = 0

export const articleCatApi = {
  // 根据父级编码获取文章分类列表
  dataByPcode(code) {
    return service.get('/www/articleCat/dataBypCode', {
      params: {
        code,
        type: WEBSITE_TYPE
      }
    })
  },
  // 根据编码获取单个文章分类
  dataByCode(code) {
    return service.get('/www/articleCat/dataByCode', {
      params: {
        code,
        type: WEBSITE_TYPE
      }
    })
  }
}
